import React from "react";
import styled from "styled-components";
import Icon from "../Icon/Icon";

//Usage: <Rating value={5} maxValue={6} />

interface RatingProps
{
    value: number;
    maxValue: number;
    isQuote?: boolean;
    starColor?: string;
}

const StarRating = styled.div`
    display: block;
    text-align: left;
    line-height: 1;
    margin-bottom: 1rem;

    &.big--stars {
        display: flex;
        justify-content: center;
        gap: 0.2rem;
    }
`;

const Star = styled.span<{ starColor?: string }>`
    display: inline-block;
    margin-right: .2rem;
    opacity: .25;
    transition: opacity .3s;
    &:last-child {
        margin-right: 0;
    }
    
    &.big--stars {
        svg {
            width: 2.7rem;
            height: 2.7rem;
        }
    }
    svg {
        width: 1.4rem;
        height: 1.4rem;
        fill: ${(props) => (props.starColor ? props.starColor : 'currentColor')};
        stroke: ${(props) => (props.starColor ? props.starColor : 'currentColor')};
    }
    &.star--active {
        opacity: 1;
    }
`;

const Rating: React.FunctionComponent<RatingProps> = (props) =>
{
    const { value, maxValue } = props;

    return (
        <StarRating className={props.isQuote ? "big--stars" : ""}>
            {[...Array(maxValue)].map((n, index) => (
                <Star key={index} starColor={props.starColor} className={`${props.isQuote ? "big--stars" : ""} ${index < value ? "star--active" : ""}`}>
                    <Icon name="star" />
                </Star>
            ))}
        </StarRating>
    );
};

export default Rating;